import * as React from "react";

export const PanelContainer = ({ title, className, children }) => {
  return (
    <div className="">
      <div className="panel-heading  prime-bg text-white text-center py-2">
        <span id="ContentPlaceHolder1_lblbannerheading ">{title}</span>
      </div>
      <div className={`${className} panel-body`}>{children}</div>
    </div>
  );
};
